"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var react_1 = __importStar(require("react"));
var react_2 = require("swiper/react");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SliderInBanner = function (_a) {
    var children = _a.children, _b = _a.containerClassName, containerClassName = _b === void 0 ? '' : _b, _c = _a.withNavigate, withNavigate = _c === void 0 ? true : _c;
    var slider = (0, react_1.useRef)(null);
    if (!children)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(containerClassName, " banner-promo-container swiper-no-swiping") },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_2.Swiper, { onBeforeInit: function (swiper) {
                        slider.current = swiper;
                    }, className: styles_module_scss_1.default.swiper, loop: true, spaceBetween: 0, slidesPerView: 1, pagination: { clickable: true }, autoplay: false }, react_1.default.Children.map(children, function (child, idx) { return (react_1.default.createElement(react_2.SwiperSlide, { key: "slider".concat(idx) }, child)); })),
                withNavigate && (react_1.default.createElement("div", { className: styles_module_scss_1.default.navigateContainer },
                    react_1.default.createElement(ui_components_1.NavigateButton, { direction: "prev", onClick: function () { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.slidePrev(); } }),
                    react_1.default.createElement(ui_components_1.NavigateButton, { direction: "next", onClick: function () { var _a; return (_a = slider === null || slider === void 0 ? void 0 : slider.current) === null || _a === void 0 ? void 0 : _a.slideNext(); } })))))));
};
exports.default = SliderInBanner;
